import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=2fd7ee34&scoped=true&"
import script from "./feedBack.vue?vue&type=script&lang=js&"
export * from "./feedBack.vue?vue&type=script&lang=js&"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=2fd7ee34&prod&lang=scss&"
import style1 from "./feedBack.vue?vue&type=style&index=1&id=2fd7ee34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd7ee34",
  null
  
)

export default component.exports